<template>
  <template v-if="isSupported">
    <slot />
  </template>
  <template v-else>
    <slot name="fallback" />
  </template>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const features = computed(() => store.getters['features/getFeatures']);

const props = defineProps({
  feature: {
    type: String,
    required: true,
  },
  limit: {
    type: Number,
    default: null,
  },
});

const isSupported = computed(() => {
  if (props.limit) {
    return (
      features.value[props.feature].is_supported &&
      (features.value[props.feature].limit !== -1
        ? features.value[props.feature].limit > props.limit
        : true)
    );
  }
  return features.value[props.feature].is_supported;
});
</script>
